import { BaseImageLoader } from "../Base/BaseImageLoader";

export class ImageLoaderWeb extends BaseImageLoader {
}